<template>
    <div>
        <v-form ref="territoryEditform" v-model="territoryEditFormValid" lazy-validation>
            <v-card>
                <v-toolbar dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-flex xs12 sm12>
                        <v-text-field 
                            :rules="[rules.required]"
                            v-model="territoryData.id" 
                            :disabled="!isNew"
                            label="Territory Id"
                            hint="Must be an Unique Value"
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field 
                            :rules="[rules.required]"
                            v-model="territoryData.name" 
                            label="Name"
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-select
                        :rules="[rules.required]"
                        label="Parent Region"
                        v-bind:items="allActiveRegions"
                        v-model="territoryData.regionId"
                        item-text="name"
                        item-value="id"
                        hint=""
                        persistent-hint
                        ></v-select>
                    </v-flex>    
                    <v-flex xs12>
                        <v-select
                        :rules="[rules.required]"
                        :items="allActiveSalesReps"
                        item-text="name"
                        item-value="id"
                        return-object
                        v-model="territoryData.salesReps"
                        label="Sales Reps"
                        multiple
                        chips
                        hint="Sales Reps of this Territory"
                        persistent-hint
                        ></v-select>
                    </v-flex>
                    <v-flex xs12>
                        <v-select
                        :rules="[rules.required]"
                        :items="allActiveCsReps"
                        item-text="name"
                        item-value="id"
                        return-object
                        v-model="territoryData.csReps"
                        label="Cust. Serv. Reps"
                        multiple
                        chips
                        hint="Customer Service Reps of this Territory"
                        persistent-hint
                        ></v-select>
                    </v-flex>
                    <v-flex xs12>
                        <v-select
                        :rules="[rules.required]"
                        :items="allActiveIsReps"
                        item-text="name"
                        item-value="id"
                        return-object
                        v-model="territoryData.isReps"
                        label="Inside Sales Reps"
                        multiple
                        chips
                        hint="Inside Sales Reps of this Territory"
                        persistent-hint
                        ></v-select>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="white hide">
                    <v-spacer></v-spacer>
                    <v-btn class="primary" @click="save()">
                    Submit
                    </v-btn>
                    <v-btn class="info" @click="cancel()">
                    Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-form>
        <!-- {{territoryData}} -->
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    props: [
        'id'
    ],
    data () {
        return {
            territoryData: {},
            allActiveSalesReps: [],
            allActiveCsReps: [],
            allActiveIsReps: [],
            allActiveRegions: [],
            territoryEditFormValid: true,
            rules: {
                required: v => !!v || "This field is required"
            },
        }
    },
    computed: {
        // id () {
        //     return this.$route.params.id
        // },
        isNew () {
            return !this.id
        },
        title () {
            return this.isNew?'Add Territory' : 'Edit Territory'
        }
    },
    methods: {
        ...mapActions('adminMarket', [
            'populateTerritoryEditModel',
            'saveTerritory',
            'getActiveRegionsSimpleData'
        ]),
        ...mapActions('adminUser', [
            'searchUsers'
        ]),
        async save() {
            if (this.$refs.territoryEditform.validate()) {
                var result = await this.saveTerritory(this.territoryData)
                if(typeof result === 'string' || result === "successful") {
                    this.$emit('onCloseTerritoryEdit')
                    return;
                } else {
                    alert(result)
                }

            }
        },
        async cancel() {
            this.$emit('onCloseTerritoryEdit')
        },
    },
    watch: {
        id: async function (newValue) {
            this.territoryData = await this.populateTerritoryEditModel(newValue)
            // this list need be updates since it could happened when new regioned add
            this.allActiveRegions = await this.getActiveRegionsSimpleData({active:true})

        }
    },
    async created () {
        this.allActiveRegions = await this.getActiveRegionsSimpleData({active:true})
        // search different sales for dropdown
        let userSearchPara = {
            userRoles: ['salesrep'],
            isActive:true,
        }
        this.allActiveSalesReps = await this.searchUsers(userSearchPara)
        userSearchPara = {
            userRoles: ['csrep'],
            isActive:true,
        }
        this.allActiveCsReps = await this.searchUsers(userSearchPara)
        userSearchPara = {
            userRoles: ['insiderep'],
            isActive:true,
        }
        this.allActiveIsReps = await this.searchUsers(userSearchPara)
        this.territoryData = await this.populateTerritoryEditModel(this.id)
    }
}
</script>
